import { useRef, useState } from 'react';
import { Plus } from 'lucide-react';
import { PortalDsButton } from 'src/components/portal-design-system';
import { IoBoldsignSearch } from './io-boldsign-search';
import { IoBoldsignTable, IoBoldsignTableRef } from './io-boldsign-table';

export function IoBoldsignView() {
  const [searchValue, setSearchValue] = useState('');
  const tableRef = useRef<IoBoldsignTableRef>(null);

  return (
    <div className="flex min-h-0 flex-1 flex-col gap-4">
      <div className="flex items-center gap-3">
        <IoBoldsignSearch
          value={searchValue}
          onChange={setSearchValue}
        />
        <div className="ml-auto">
          <PortalDsButton
            variant="accent"
            onClick={() => tableRef.current?.createNew()}
          >
            <Plus className="h-4 w-4" />
            New IO
          </PortalDsButton>
        </div>
      </div>
      <div className="relative min-h-0 flex-1 overflow-auto">
        <IoBoldsignTable
          ref={tableRef}
          searchValue={searchValue}
        />
      </div>
    </div>
  );
}
